import { createReducer } from '@reduxjs/toolkit';
import * as actionTypes from 'modules/customers/actionTypes';

/**
 * @typedef {string | null} SelectedCustomerIdState
 */
/** @type {SelectedCustomerIdState} */
const initialState = null;

/**
 * @param {SelectedCustomerIdState} state
 * @param {import('modules/customers/types').PostUnsubscribeSuccessAction} params
 * @returns {SelectedCustomerIdState}
 */
const set = (state, { payload }) => payload.customerInfo?.id ?? state;

export default createReducer(initialState, (builder) => {
  builder.addCase(actionTypes.POST_CUSTOMER_LEADS_UNSUBSCRIBE_SUCCESS, set);
});
